import { NotAuthorized } from "@/components/NotAuthorized";
import { LoadingState } from "@/components/podkit/loading/LoadingState";
import { Text } from "@/components/podkit/typography/Text";
import { useDocumentTitle } from "@/hooks/use-document-title";
import { useFlagOnaAIEnabled, useFlagCommandsAreSkills } from "@/hooks/use-flag";
import { useMembership } from "@/hooks/use-membership";
import { AgentSkills } from "@/routes/settings/organization/agents/AgentSkills";
import { AgentCommands } from "@/routes/settings/organization/agents/AgentCommands";
import { AgentPolicies } from "@/routes/settings/organization/agents/AgentPolicies";
import { OrganizationRole } from "gitpod-next-api/gitpod/v1/organization_pb";
import type { FC } from "react";

export const AgentsPage: FC = () => {
    useDocumentTitle("Agents");

    const { membership, isPending: isLoadingMembership } = useMembership();
    const { value: isOnaAIEnabled, loading: isLoadingOnaAI } = useFlagOnaAIEnabled();
    const { value: commandsAreSkills, loading: isLoadingCommandsAreSkills } = useFlagCommandsAreSkills();

    if (!membership && isLoadingMembership) {
        return <LoadingState />;
    }

    if (membership?.userRole !== OrganizationRole.ADMIN) {
        return <NotAuthorized />;
    }

    if (isLoadingOnaAI || isLoadingCommandsAreSkills) {
        return <LoadingState />;
    }

    if (!isOnaAIEnabled) {
        return <NotAuthorized />;
    }

    const descriptionText = commandsAreSkills
        ? "Configure agent skills and policies for your organization."
        : "Configure agent commands and policies for your organization.";

    return (
        <div className="flex flex-col gap-6" data-testid="agents-page">
            <Text className="text-base text-content-secondary">{descriptionText}</Text>

            <AgentPolicies />
            {commandsAreSkills ? <AgentSkills /> : <AgentCommands />}
        </div>
    );
};
